// work data




export const Works = [
  {
    "id": 1008,
    "name": "Bethanys Pie Shop",
    "tags": "#ASP.Net Core, #C, #Ecommerce",
    "discription": "Bethany Pie Shop is an E-commerce project related to pies to buy.",
    "codeLink": "https://github.com/Moglten/Semeter-Fall",
    "liveLink": "http://bethanypieshop.somee.com/"
}
,
  
{
    "id": 10021,
    "name": "Github User Finder",
    "tags": "#JavaScript, #Github, #Bootstrap",
    "discription": "Github User Finder Is a web application that gets the GitHub account and its details by the username.",
    "codeLink": "https://github.com/Moglten/Github-User-Finder",
    "liveLink": "https://friendly-lamington-cd301b.netlify.app/"
}
,
  {
      "id": 1,
      "name": "Mall related RESTful API",
      "tags": "#HTTP, #C, #ASP.Net Core",
      "discription": "The Mall-related-APi is a Client Server Service that uses HTTP requests to access and use data. That data can be used to GET, PUT, POST and DELETE, Http request.",      "codeLink": "https://github.com/Moglten/RESTful-Mall-related-API",
      "liveLink": "https://github.com/Moglten/RESTful-Mall-related-API"
  },
  {
      "id": 2,
      "name": "BreakOut Game",
      "tags": "#Python, #pygame, #game",
      "discription": "BreakOut game is a python atari game.",
      "codeLink": "https://github.com/Moglten/BreakOut-Game",
      "liveLink": "https://github.com/Moglten/BreakOut-Game"
  },
  {
      "id": 1002,
      "name": "Products GraphQL APi",
      "tags": "#API, #C, #GraphQL",
      "discription": "The product API is GraphQl api mobile user oriantation with developer service like filter, cache, sort etc.",
      "codeLink": "https://github.com/Moglten/Product-GraphQL-APi",
      "liveLink": "https://github.com/Moglten/Product-GraphQL-APi"
  },
  {
      "id": 1003,
      "name": "Semeter Fall Schdular",
      "tags": "#ASP.Net Core, #C, #Educational",
      "discription": "An Asp.Net core app to help college institutes easily creates the full year schedule.",
      "codeLink": "https://github.com/Moglten/Semeter-Fall",
      "liveLink": "https://github.com/Moglten/Semeter-Fall"
  }
  ,
  {
      "id": 100355,
      "name": "ETicket Store",
      "tags": "#ASP.Net Core, #C, #e-commerce",
      "discription": "E-commerce project that aims to sell tickets for films in the nearest and subscribers cinemas.",
      "priority": 1,
      "codeLink": "https://github.com/Moglten/ETickets-ecommerce",
      "liveLink": "https://github.com/Moglten/ETickets-ecommerce"
  }

 
]

export default Works;